import { render } from "./HeaderConfigurator.vue?vue&type=template&id=0ffefc1e&ts=true"
import script from "./HeaderConfigurator.vue?vue&type=script&lang=ts"
export * from "./HeaderConfigurator.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__